import { graphClient, gql } from '../graphql'

let queryQuotes

export const voteQuote = ({commit}, { quote, vote }) => {
  let variables = {
    quoteId: quote.id,
    vote
  }

  let actionType = {
    action: 'addVote',
    type: 'AddVoteInput'
  }

  if (quote.myVote) {
    actionType = {
      action: 'editVote',
      type: 'EditVoteInput'
    }
    variables.quoteId = undefined
    variables.id = quote.myVote.id
  }

  const mutateVote = gql`
    mutation ${actionType.action}($input: ${actionType.type}!) {
      ${actionType.action}(input: $input) {
        ranking
        vote {
          id
          vote
        }
        ok
      }
    }
  `

  return graphClient.mutate({
    mutation: mutateVote,
    variables: {
      input: variables
    }
  })
    .then(data => {
      if (actionType.action === 'addVote') {
        return commit('SET_VOTE', {
          quote: quote,
          ranking: data.data.addVote.ranking,
          vote: data.data.addVote.vote
        })
      }

      return commit('SET_VOTE', {
        quote: quote,
        ranking: data.data.editVote.ranking,
        vote: data.data.editVote.vote
      })
    })
    .catch(err => console.error(err))
}

export const deleteQuote = ({commit}, quote) => {
  const deleteQuoteQuery = gql`
    mutation deleteQuote($input: DeleteQuoteInput!) {
      deleteQuote(input: $input) {
        ok
      }
    }
  `

  return graphClient.mutate({
    mutation: deleteQuoteQuery,
    variables: {
      input: {
        id: quote.id
      }
    }
  })
    .then(data => commit('DELETE_QUOTE', quote))
    .catch(err => console.error(err))
}

export const setActiveQuote = ({commit}, quote) =>
  commit('SET_ACTIVE_QUOTE', quote)

export const setChangeQuotes = ({commit}, data) =>
  commit('SET_CHANGE_QUOTES', data)

export const mutateQuote = ({ commit, state }, newQuote) => {
  let actionType = {
    action: 'addQuote',
    type: 'AddQuoteInput'
  }

  if (state.activeQuote.id) {
    actionType = {
      action: 'editQuote',
      type: 'EditQuoteInput'
    }
  }

  const mutateQuoteQuery = gql`
    mutation ${actionType.action}($input: ${actionType.type}!) {
      ${actionType.action}(input: $input) {
        quote {
          id
          quote
          dateTime
          ranking
          author {
            name
            id
          }
          externalAuthor
          explanation
        }
        ok
      }
    }
  `

  let quote = {
    quote: newQuote.quote
  }

  if (state.activeQuote.id) {
    quote.id = state.activeQuote.id
  }

  if (newQuote.explanation) {
    quote.explanation = newQuote.explanation
  }

  if (newQuote.author) {
    quote.authorId = newQuote.author
  } else {
    quote.externalAuthor = newQuote.externalAuthor
  }

  return graphClient.mutate({
    mutation: mutateQuoteQuery,
    variables: {
      input: quote
    }
  })
    .then(data => {
      if (state.activeQuote.id) {
        return commit('EDIT_QUOTE', data.data.editQuote.quote)
      }
      return commit('ADD_QUOTE', data.data.addQuote.quote)
    })
    .catch(err => console.error(err))
}

export const me = ({ commit }) => {
  const getMe = gql`
    query {
      me {
        name
        picture
      }
    }
  `

  return graphClient.query({
    query: getMe
  })
    .then(data => commit('ME', data.data.me))
}

export const kaleiders = ({ commit }) => {
  const getKaleiders = gql`
    query ($first: Int, $after: String) {
      kaleiders(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            name
            email
            picture
          }
        }
      }
    }
  `

  return graphClient.query({
    query: getKaleiders
  })
    .then(data => commit('KALEIDERS', data.data.kaleiders.edges))
}

export const filterQuotes = ({ commit, state }, filter) => {
  let getQuotes = gql`
    query QuotesFilter(
      $first: Int,
      $after: String,
      $authorId: ID,
      $orderBy: String
    ) {
      quotes(
        first: $first,
        after: $after,
        authorId: $authorId,
        orderBy: $orderBy
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            quote
            dateTime
            ranking
            author {
              name
              id
            }
            externalAuthor
            explanation
            myVote {
              id
              vote
            }
          }
        }
      }
    }
  `

  const GET_QUOTES = {
    query: getQuotes
  }

  GET_QUOTES.variables = Object.assign({}, state.pager, { after: undefined })

  if (filter) {
    Object.assign(GET_QUOTES.variables, filter)
  }

  queryQuotes = graphClient.watchQuery(GET_QUOTES)

  queryQuotes.subscribe({
    next (quotes) {
      commit('FILTER_QUOTES', {
        quotes: quotes.data.quotes.edges.map(item => item.node),
        pager: {
          after: quotes.data.quotes.pageInfo.endCursor,
          first: 20
        }
      })
    }
  })
}

export const showMore = ({commit, state}, quotes) => queryQuotes.fetchMore({
  variables: state.pager,

  updateQuery: (previousResult, { fetchMoreResult }) =>
    commit('MORE_QUOTES', {
      quotes: fetchMoreResult.data.quotes.edges.map(item => item.node),
      pager: {
        after: fetchMoreResult.data.quotes.pageInfo.endCursor
      }
    })
})

export const changeFiltersVisibility = ({commit}) => commit('FILTER_VISIBILITY')



// WEBPACK FOOTER //
// ./src/vuex/actions.js